import type { ReactNode } from "react";
import * as palette from "../palette";

interface IInlineAssetDiscussionCommentErrorProps {
  children: ReactNode;
}

export default function InlineAssetDiscussionCommentError({ children }: IInlineAssetDiscussionCommentErrorProps) {
  return (
    <div
      css={{
        display: "inline-flex",
        padding: "8px 12px",
        color: palette.stiletto,
        backgroundColor: palette.vanillaIce,
        borderRadius: 6,
      }}
    >
      <p
        css={{
          display: "inline-flex",
          margin: 0,
          fontWeight: 500,
          fontSize: 14,
          lineHeight: 1.33,
          letterSpacing: 1,
        }}
      >
        {children}
      </p>
    </div>
  );
}
